var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"col-12 col-md-5 py-4"},[_c('img',{staticClass:"w-100",attrs:{"src":'/assets/images/systems/' + _vm.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }